import Base from './base'

export default class ReportingDocument extends Base {
  list() {
    return this.apiClient.get('frequencies')
  }
}
